module.exports = __webpack_public_path__ + "img/australianrules-dark.380de59d.svg";